import ApiBase from './base/ApiBase'
import {ICreateProficiency, Proficiency, ProficiencyType} from '../models/dtos';

class ProficiencyClient extends ApiBase
{
    private controllerName: string = 'Proficiency';

    async Create(dto: ICreateProficiency, signal?: AbortSignal) : Promise<string>
    {
        return this.PostAsync(`${this.controllerName}`, dto, signal);
    }

    async Delete(id: string, signal?: AbortSignal) : Promise<void>
    {
        return this.DeleteAsync(`${this.controllerName}/${id}`, signal);
    }

    async GetAll(templateId?: string, signal?: AbortSignal) : Promise<Proficiency[]>
    {
        let url = (templateId === undefined) ? `${this.controllerName}` : `${this.controllerName}?templateid=${templateId}`;
        return this.GetAsync(url, signal);
    }

    async GetSingle(id: string, signal?: AbortSignal) : Promise<Proficiency>
    {
        return this.GetAsync(`${this.controllerName}/${id}`, signal);
    }

    async Update(dto: UpdateProficiency, signal?: AbortSignal) : Promise<void>
    {
        return this.PutAsync(`${this.controllerName}/${dto.Id}`, dto, signal);
    }

}

export interface UpdateProficiency {
    Id: string;
    Type: ProficiencyType;
    Name: string;
    Weight: number;
    IsNegative: boolean;
    Notes: string;
   }

export enum ProficiencyErrors
{
    Create = 'Error creating Proficiency',
    Delete = 'Error deleting Proficiency',
    GetAll = 'Error loading Proficiencies',
    GetSingle = 'Error loading Proficiency',
    Update = 'Error saving Proficiency',

}

export default ProficiencyClient;